import { defineComponent, onMounted, ref, reactive, watch } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useI18n } from "vue-i18n";
import { getBackgroundImage, getKeyValues } from "../../Tools";
import { theme_color } from "@/theme";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "HeaderBox",
  props: {
    data: Array
  },
  setup(props) {
    const {
      locale
    } = useI18n();
    const enUS = ref(true);
    const switchLanguage = ref(true);
    const localeLanguage = ref("中");
    //const showSubMenu=ref(false)
    //当前选中的导航索引
    const navIndex = ref(0);
    //当前子菜单索引
    //const subMenuIndex=ref(-1)
    //当前子菜单数据
    const subMenuData = reactive({
      title: "",
      subMenu: {
        img: "",
        list: [],
        link: ""
      }
    });
    const route = useRoute();
    const changeLanguage = () => {
      switchLanguage.value = !switchLanguage.value;
      localeLanguage.value = switchLanguage.value ? "中" : "EN";
      locale.value = switchLanguage.value ? "en-US" : "zh-CN";
      //   console.log(enUS.value);
      //   if (enUS.value) {
      //     locale.value = "en-US";
      //   } else {
      //     locale.value = "zh-CN";
      //   }
    };
    const onMenuMouseEnter = i => {
      //subMenuIndex.value=i
      //showSubMenu.value=true
      //console.log(i)
      if (props.data) {
        console.log(props.data[i].subMenu);
        subMenuData.subMenu = props.data[i].subMenu;
      }
    };
    const onShowProduct = sub => {
      console.log(sub);
    };
    onMounted(() => {
      watch(() => route.params.name, () => {
        console.log(route.path);
        switch (route.path) {
          case "/":
            navIndex.value = 0;
            break;
          case "/honor":
            navIndex.value = 1;
            break;
          case "/about":
            navIndex.value = 2;
            break;
          case "/class/kitchen":
            navIndex.value = 3;
            break;
          case "/class/bathroom":
            navIndex.value = 4;
            break;
          case "/class/WaterSaving":
            navIndex.value = 5;
            break;
          case "/class/other":
            navIndex.value = 6;
            break;
          default:
            navIndex.value = -1;
        }
      });
    });
    return {
      enUS,
      localeLanguage,
      Search,
      subMenuData,
      theme_color,
      navIndex,
      changeLanguage,
      getBackgroundImage,
      getKeyValues,
      onShowProduct
    };
  }
});